import { InjectionToken } from '@angular/core';
import type { Faro } from '@grafana/faro-web-sdk';
import { faro } from '@grafana/faro-web-sdk';

/**
 * The Faro SDK singleton behind an injection token so specs can provide a spy
 * instead of the module-level export. Before `initializeFaro` runs, the
 * singleton is an empty object (`faro.api` is undefined) — consumers must
 * guard on that.
 */
export const FARO = new InjectionToken<Faro>('faro', { factory: () => faro });
